import { queryKeys } from '@sshop/api-client';

import { api } from '@/shared/lib/apiClient';
import { defineQuery } from '@/shared/lib/queryFactory';

export const newsListQuery = (page: number, pageSize: number) =>
  defineQuery({
    queryKey: queryKeys.news.list(page, pageSize),
    queryFn: ({ signal }) => api.news.list({ page, pageSize }, signal),
    staleTime: 60_000,
  });

export const newsDetailQuery = (slug: string) =>
  defineQuery({
    queryKey: queryKeys.news.detail(slug),
    queryFn: ({ signal }) => api.news.get(slug, signal),
    staleTime: 5 * 60_000,
  });
